module.exports = __webpack_public_path__ + "img/Beginner-1.b3b9e458.png";